import {lazyLoadObserve} from './lazyLoad'
import AirDatepicker from 'air-datepicker'
import fr from 'air-datepicker/locale/fr';

const programs = document.querySelector('.js-programs-results');
const inputDate = document.querySelector('.js-programs-date');
const btnReinitDate = document.querySelector('.js-dialog-reinit-date')
const btnDates = document.querySelector('.js-program-btn-dates');
const btnLocation = document.querySelector('.js-program-btn-location');
let throttle = 0;

const loadResults = (paged = 1) => {
  updateBadges();

  const apiRoute = programs.dataset.apiRoute;
  const dateStart = inputDate.dataset.start ? inputDate.dataset.start : 0;
  const dateEnd = inputDate.dataset.end ? inputDate.dataset.end : 0;
  let taxonomy;
  const locations = [];
  const newRoute = new URL(window.location.toString())
  newRoute.search = ''
  if (paged > 1)
    newRoute.searchParams.set('_p', paged);

  const inputCat = document.querySelector('.js-programs-cat:checked');
  const inputLocations = document.querySelectorAll('.js-programs-location:checked');

  inputLocations.forEach((input) => locations.push(input.value))

  if (inputCat.value === 'all') {
    taxonomy = '0'
  } else {
    taxonomy = inputCat.value
    newRoute.searchParams.set('_cat', taxonomy)
  }
  if (locations.length === 0) {
    locations.push(0);
  }

  const query = `${dateStart}/${dateEnd}/${locations}/${taxonomy}/${paged}`;

  clearTimeout(throttle);
  throttle = setTimeout(async () => {
    try {
      const response = await fetch(`${apiRoute}${query}`);
      const result = await response.text();
      programs.innerHTML = result;
      if (window.location.toString() !== newRoute.toString()) {
        window.history.pushState(null, '', newRoute.toString());
      }
      window.scrollTo(0,0);
      initEvents();
      const observer = lazyLoadObserve(programs);
      observer.observe();
    } catch {
      //
    }
  }, 500);
}

const updateBadges = () => {
  const inputLocations = document.querySelectorAll('.js-programs-location:checked');

  btnLocation.classList.toggle('button--badge', inputLocations.length > 0);
  btnDates.classList.toggle('button--badge', typeof inputDate.dataset.start !== 'undefined' && inputDate.dataset.start)
}

const initEvents = () => {
  const paginations = [...document.getElementsByClassName('js-programs-pagination')];

  paginations.forEach((pagination) => {
    pagination.addEventListener('click', (e) => {
      e.preventDefault()
      const href = pagination.getAttribute('href')
      const searchParams = new URLSearchParams(href);
      const paged = searchParams.get('_p')
      loadResults(paged);
    })
  })
}

if (programs) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const cat = urlParams.get('_cat')

  if (cat) {
    const inputTypes = [...document.getElementsByClassName('js-programs-cat')];
    inputTypes.forEach((input) => {
      input.checked = cat === input.value
    })
  }

  initEvents()
  updateBadges()

  const filters = [...document.getElementsByClassName('js-programs-filters')];
  filters.forEach((input) => {
    input.addEventListener('input', (e) => {
      e.preventDefault()
      loadResults()
    })
  })

  const datePicker = new AirDatepicker(
    inputDate,
    {
      locale: fr,
      isMobile: window.innerWidth < 768,
      buttons: ['clear', {
        content: inputDate.dataset.labelValidate,
        onClick: (dp) => {
          dp.hide();
        }
      }],
      minDate: inputDate.dataset.min,
      maxDate: inputDate.dataset.max,
      range: true,
      multipleDatesSeparator: ' → ',
      onSelect({date:dates, datepicker: dp}) {
        if (dates.length > 1) {
          inputDate.dataset.start = dp.formatDate(dates[0], 'yyyy-MM-dd');
          inputDate.dataset.end = dp.formatDate(dates[1], 'yyyy-MM-dd');
        } else if (dates.length === 1) {
          const formatDate = dp.formatDate(dates[0], 'yyyy-MM-dd');
          inputDate.dataset.start = formatDate;
          inputDate.dataset.end = formatDate;
        } else {
          inputDate.removeAttribute('data-start');
          inputDate.removeAttribute('data-end');
        }

        loadResults();
      },
    }
  );

  btnReinitDate.addEventListener('click', () => {
    datePicker.clear()
  })

  window.addEventListener('resize', () => {
    const isMobile = window.innerWidth < 768
    datePicker.update({
      isMobile
    })
  })
}
